<template>
  <form class="form" @submit="submitForm">
    <div class="form-group">
      <div class="sizes-container">
        <div @click="this.topsOpen = !this.topsOpen" v-b-toggle.collapse-apparel-tops variant="primary" class="size-options-label-container">
          <span class="size-options-label">Tops</span>
          <div v-if="!tabsOpen">
            <img v-if="!topsOpen" src="../assets/images/arrow_down.svg" />
            <img v-if="topsOpen" src="../assets/images/arrow_up.svg" />
          </div>
        </div>
        <b-collapse :visible="this.tabsOpen" id="collapse-apparel-tops" class="mt-2">
          <b-card>
            <div class="size-options-container">
              <div class="size-option" :class="{'checked': this.formData.tops.includes(size)}" :key="size" v-for="size of dictionaries.apparelSizes" @click="updateSizes(this.formData.tops, size, 'tops')">
                <span v-if="this.formData.tops.includes(size) && this.formData.topsConfirmed">{{ `${size}*` }}</span>
                <span v-else>{{ size }}</span>
              </div>
            </div>
          </b-card>
          <div class="size-confirmation-container">
            <input v-model="this.formData.topsConfirmed" type="checkbox" class="checkbox-custom">
            <label>Size(s) confirmed</label>
          </div>
        </b-collapse>
      </div>
      <div class="sizes-container">
        <div @click="this.bottomsOpen = !this.bottomsOpen" v-b-toggle.collapse-apparel-bottoms variant="primary" class="size-options-label-container">
          <span class="size-options-label">Bottoms</span>
          <div v-if="!tabsOpen">
            <img v-if="!bottomsOpen" src="../assets/images/arrow_down.svg" />
            <img v-if="bottomsOpen" src="../assets/images/arrow_up.svg" />
          </div>
        </div>
        <b-collapse :visible="this.tabsOpen" id="collapse-apparel-bottoms" class="mt-2">
          <b-card>
            <div class="size-options-container">
              <div class="size-option" :class="{'checked': this.formData.bottoms.includes(size)}" :key="size" v-for="size of dictionaries.apparelSizes" @click="updateSizes(this.formData.bottoms, size, 'bottoms')">
                <span v-if="this.formData.bottoms.includes(size) && this.formData.bottomsConfirmed">{{ `${size}*` }}</span>
                <span v-else>{{ size }}</span>
              </div>
            </div>
          </b-card>
          <div class="size-confirmation-container">
            <input v-model="this.formData.bottomsConfirmed" type="checkbox" class="checkbox-custom">
            <label>Size(s) confirmed</label>
          </div>
        </b-collapse>
      </div>
      <div class="sizes-container">
        <div @click="this.headwearOpen = !this.headwearOpen" v-b-toggle.collapse-apparel-headwear variant="primary" class="size-options-label-container">
          <span class="size-options-label">Headwear</span>
          <div v-if="!tabsOpen">
            <img v-if="!headwearOpen" src="../assets/images/arrow_down.svg" />
            <img v-if="headwearOpen" src="../assets/images/arrow_up.svg" />
          </div>
        </div>
        <b-collapse :visible="this.tabsOpen" id="collapse-apparel-headwear" class="mt-2">
          <b-card>
            <div class="size-options-container">
              <div class="size-option" :class="{'checked': this.formData.fitted_hats.includes(size)}" :key="size" v-for="size of dictionaries.headwearSizes" @click="updateSizes(this.formData.fitted_hats, size, 'fitted_hats')">
                <span v-if="this.formData.fitted_hats.includes(size) && this.formData.headwearConfirmed">{{ `${size}*` }}</span>
                <span v-else>{{ size }}</span>
              </div>
            </div>
          </b-card>
          <div class="size-confirmation-container">
            <input v-model="this.formData.headwearConfirmed" type="checkbox" class="checkbox-custom">
            <label>Size(s) confirmed</label>
          </div>
        </b-collapse>
      </div>
      <div class="sizes-container">
        <div @click="this.footwearOpen = !this.footwearOpen" v-b-toggle.collapse-apparel-footwear variant="primary" class="size-options-label-container">
          <span class="size-options-label">Footwear</span>
          <div v-if="!tabsOpen">
            <img v-if="!footwearOpen" src="../assets/images/arrow_down.svg" />
            <img v-if="footwearOpen" src="../assets/images/arrow_up.svg" />
          </div>
        </div>
        <b-collapse :visible="this.tabsOpen" id="collapse-apparel-footwear" class="mt-2">
          <b-card>
            <div class="size-options-container">
              <div class="size-option" :class="{'checked': this.formData.footwear.includes(size)}" :key="size" v-for="size of dictionaries.footwearSizes" @click="updateSizes(this.formData.footwear, size, 'footwear')">
                <span v-if="this.formData.footwear.includes(size) && this.formData.footwearConfirmed">{{ `${size}*` }}</span>
                <span v-else>{{ size }}</span>
              </div>
            </div>
          </b-card>
          <div class="size-confirmation-container">
            <input v-model="this.formData.footwearConfirmed" type="checkbox" class="checkbox-custom">
            <label>Size(s) confirmed</label>
          </div>
        </b-collapse>
      </div>
      <div class="sizes-container">
        <div @click="this.accessoriesOpen = !this.accessoriesOpen" v-b-toggle.collapse-apparel-accessories variant="primary" class="size-options-label-container">
          <span class="size-options-label">Accessories</span>
          <div v-if="!tabsOpen">
            <img v-if="!accessoriesOpen" src="../assets/images/arrow_down.svg" />
            <img v-if="accessoriesOpen" src="../assets/images/arrow_up.svg" />
          </div>
        </div>
        <b-collapse :visible="this.tabsOpen" id="collapse-apparel-accessories" class="mt-2">
          <b-card>
            <div class="size-options-container">
              <div class="size-option" :class="{'checked': this.formData.accessories.includes(size)}" :key="size" v-for="size of dictionaries.apparelSizes" @click="updateSizes(this.formData.accessories, size, 'accessories')">
                <span v-if="this.formData.accessories.includes(size) && this.formData.accessoriesConfirmed">{{ `${size}*` }}</span>
                <span v-else>{{ size }}</span>
              </div>
            </div>
          </b-card>
          <div class="size-confirmation-container">
            <input v-model="this.formData.accessoriesConfirmed" type="checkbox" class="checkbox-custom">
            <label>Size(s) confirmed</label>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="buttons">
      <button type="submit" name="submit" class="btn btn--primary">
        {{ $attrs['button-text'] }}
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    tops: {
      type: Array,
      default() {
        return []
      }
    },
    bottoms: {
      type: Array,
      default() {
        return []
      }
    },
    footwear: {
      type: Array,
      default() {
        return []
      }
    },
    fittedHats: {
      type: Array,
      default() {
        return []
      }
    },
    accessories: {
      type: Array,
      default() {
        return []
      }
    },
    topsConfirmed: {
      type: Boolean,
      default() {
        return false
      }
    },
    bottomsConfirmed: {
      type: Boolean,
      default() {
        return false
      }
    },
    headwearConfirmed: {
      type: Boolean,
      default() {
        return false
      }
    },
    footwearConfirmed: {
      type: Boolean,
      default() {
        return false
      }
    },
    accessoriesConfirmed: {
      type: Boolean,
      default() {
        return false
      }
    },
    tabsOpen: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      topsOpen: false,
      bottomsOpen: false,
      headwearOpen: false,
      footwearOpen: false,
      accessoriesOpen: false,
      formData: {
        tops: this.tops,
        bottoms: this.bottoms,
        fitted_hats: this.fittedHats,
        footwear: this.footwear,
        accessories: this.accessories,
        topsConfirmed: this.topsConfirmed,
        bottomsConfirmed: this.bottomsConfirmed,
        headwearConfirmed: this.headwearConfirmed,
        footwearConfirmed: this.footwearConfirmed,
        accessoriesConfirmed: this.accessoriesConfirmed,
      }
    }
  },
  emits: ["sizingFormSubmitted"],
  mounted() {
    console.log(this.tops, this.formData)
  },
  methods: {
    updateSizes(array, size, element) {
      const exists = array.includes(size)

      if (exists) {
        this.formData[element] = array.filter((s) => s != size)
      } else {
        array.push(size)
      }
    },
    submitForm(e) {
      e.preventDefault()
      console.log('>>', this.formData);

      var newFormData = {
        tops: this.formData.tops,
        bottoms: this.formData.bottoms,
        fitted_hats: this.formData.fitted_hats,
        footwear: this.formData.footwear,
        accessories: this.formData.accessories,
        topsConfirmed: this.formData.topsConfirmed,
        bottomsConfirmed: this.formData.bottomsConfirmed,
        headwearConfirmed: this.formData.headwearConfirmed,
        footwearConfirmed: this.formData.footwearConfirmed,
        accessoriesConfirmed: this.formData.accessoriesConfirmed,
      }

      if(this.$attrs['button-text'] === 'Update') {
        newFormData = {
          tops: this.formData.tops,
          bottoms: this.formData.bottoms,
          fitted_hats: this.formData.fitted_hats,
          footwear: this.formData.footwear,
          accessories: this.formData.accessories,
          tops_sizes_confirmed: this.formData.topsConfirmed,
          bottoms_sizes_confirmed: this.formData.bottomsConfirmed,
          footwear_sizes_confirmed: this.formData.footwearConfirmed,
          headwear_sizes_confirmed: this.formData.headwearConfirmed,
          accessories_sizes_confirmed: this.formData.accessoriesConfirmed

        }
      }

      console.log('>>', this.newFormData);
      this.$emit('sizingFormSubmitted', newFormData, e.target)
    }
  }
}
</script>
<style scoped>
  .sizes-container {
    border-bottom: 1px solid #E5E5E5;
    padding: 10px 0;
    margin-bottom: 5px;
  }
  .size-options-label-container {
    display: flex;
    justify-content: space-between;
  }
  .size-options-label-container:hover {
    cursor: pointer;
  }
  .size-options-container {
    display: flex;
    flex-direction: row;
    margin-top: 5px;
    flex-wrap: wrap;
    width: 80%;
  }
  .size-option {
    height: 40px;
    width: 40px;
    background-color: white;
    border: 1px solid #E5E5E5;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 3px;
    margin-bottom: 8px;
  }

  .size-option.checked {
    border: 1px solid black;
  }

  .size-option:hover {
    cursor: pointer;
  }

  .size-confirmation-container {
    display: flex;
    align-items: center;
  }

  .checkbox-custom::after {
  content: '';
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid black;
  border-radius: 0;
  background-color: white;
}

label {
  margin-left: 8px;
}

.checkbox-custom:checked::after {
  background-color: black;
  font-size: 20px;
  line-height: 1em;
  width: 12px;
  height: 12px;
  color: white;
  text-align:center;
}
</style>
